module.exports = __webpack_public_path__ + "img/timelapse_green.934de89c.svg";